import { deleteRequest, getRequest, patchRequest, postRequest } from 'services/requests';

const services = {
    createAccount: (id, body) => postRequest(`/accounts/${id}`, body),
    findAccount: (id) => getRequest(`/accounts/${id}`),
    updateAccount: (id, body) => patchRequest(`/accounts/${id}`, body),
    deleteAccount: (id) => deleteRequest(`/accounts/${id}`),
    findAccountFiles: (id) => getRequest(`/accounts/${id}/files`),
    findAccountSharedUrls: (id) => getRequest(`/accounts/${id}/shared-urls`),
    findAccountTasks: (id) => getRequest(`/accounts/${id}/tasks`),
    getAccountTokens: (id) => getRequest(`/accounts/${id}/tokens`),
};

export default services;
